/**
 * Display helpers for one monitoring location, shared by Location Details
 * (desktop) and the phone layout: the freshness banner colours and the
 * logger battery text.
 *
 * Pure values and functions (no React, no API calls).
 */
import type { OnlineLevel } from '../../utils/onlineStatus';

/** Freshness banner colours per level (tinted background, dark text). */
export const FRESHNESS_TINTS: Record<OnlineLevel, { bg: string; fg: string }> = {
  online: { bg: '#E1F5EE', fg: '#0f6e56' },
  delayed: { bg: '#FAEEDA', fg: '#9a6a00' },
  offline: { bg: '#FDECEA', fg: '#A32D2D' },
  ended: { bg: '#EDEDED', fg: '#5f5f5f' },
  scheduled: { bg: '#E6F1FB', fg: '#185FA5' },
};

/** Format battery enum values like "ONE_HUNDRED_PERCENT" as "100%"; 'N/A'
 *  without a value, and any other value in lower case without underscores. */
export const formatBatteryLevel = (value?: string) => {
  if (!value) return 'N/A';
  const batteryMap: Record<string, string> = {
    'ONE_HUNDRED_PERCENT': '100%',
    'NINETY_PERCENT': '90%',
    'EIGHTY_PERCENT': '80%',
    'SEVENTY_FIVE_PERCENT': '75%',
    'SEVENTY_PERCENT': '70%',
    'SIXTY_PERCENT': '60%',
    'FIFTY_PERCENT': '50%',
    'FORTY_PERCENT': '40%',
    'THIRTY_PERCENT': '30%',
    'TWENTY_FIVE_PERCENT': '25%',
    'TWENTY_PERCENT': '20%',
    'TEN_PERCENT': '10%',
    'FIVE_PERCENT': '5%',
    'ZERO_PERCENT': '0%',
  };
  return batteryMap[value] || value.replace(/_/g, ' ').toLowerCase();
};
